"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId } from "react";
import { cn } from "../../../../shared/utils/cn.js";
/**
 * Animated checkmark SVG component.
 * Circle draws in → checkmark draws → background fills → subtle scale bounce.
 *
 * Size is controlled via className (Tailwind classes like `h-10 w-10`, `h-16 w-16`, etc.).
 * The SVG scales to fit its container via viewBox.
 */
export function AnimatedCheckmark(t0) {
  const $ = _c(10);
  const {
    color: t1,
    checkColor: t2,
    strokeWidth: t3,
    className,
    delay: t4,
    static: t5
  } = t0;
  const color = t1 === undefined ? "#22c55e" : t1;
  const checkColor = t2 === undefined ? "#fff" : t2;
  const strokeWidth = t3 === undefined ? 2 : t3;
  const delay = t4 === undefined ? 0 : t4;
  const isStatic = t5 === undefined ? false : t5;
  const id = `ac-${useId().replace(/:/g, "")}`;
  if (isStatic) {
    const t6 = `inset 0px 0px 0px 100px ${color}`;
    let t7;
    if ($[0] !== checkColor || $[1] !== className || $[2] !== color || $[3] !== strokeWidth || $[4] !== t6) {
      t7 = _jsxs("svg", {
        className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        style: {
          borderRadius: "50%",
          display: "block",
          strokeWidth,
          stroke: checkColor,
          strokeMiterlimit: 10,
          boxShadow: t6
        },
        children: [_jsx("circle", {
          cx: "26",
          cy: "26",
          r: "25",
          fill: "none",
          style: {
            strokeWidth,
            strokeMiterlimit: 10,
            stroke: color
          }
        }), _jsx("path", {
          fill: "none",
          d: "M14.1 27.2l7.1 7.2 16.7-16.8",
          style: {
            transformOrigin: "50% 50%"
          }
        })]
      });
      $[0] = checkColor;
      $[1] = className;
      $[2] = color;
      $[3] = strokeWidth;
      $[4] = t6;
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    return t7;
  }
  const t6 = `
@keyframes ${id}-stroke {
  100% { stroke-dashoffset: 0; }
}
@keyframes ${id}-scale {
  0%, 100% { transform: none; }
  50% { transform: scale3d(1.1, 1.1, 1); }
}
@keyframes ${id}-fill {
  100% { box-shadow: inset 0px 0px 0px 100px ${color}; }
}
.${id} {
  border-radius: 50%;
  display: block;
  stroke-width: ${strokeWidth};
  stroke: ${checkColor};
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px ${color};
  animation:
    ${id}-fill .4s ease-in-out ${delay + 0.4}s forwards,
    ${id}-scale .3s ease-in-out ${delay + 0.9}s both;
}
.${id}__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: ${strokeWidth};
  stroke-miterlimit: 10;
  stroke: ${color};
  fill: none;
  animation: ${id}-stroke .6s cubic-bezier(0.65, 0, 0.45, 1) ${delay}s forwards;
}
.${id}__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: ${id}-stroke .3s cubic-bezier(0.65, 0, 0.45, 1) ${delay + 0.8}s forwards;
}
`;
  let t7;
  if ($[6] !== className || $[7] !== id || $[8] !== t6) {
    t7 = _jsxs(_Fragment, {
      children: [_jsx("style", {
        dangerouslySetInnerHTML: {
          __html: t6
        }
      }), _jsxs("svg", {
        className: cn(id, className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        children: [_jsx("circle", {
          className: `${id}__circle`,
          cx: "26",
          cy: "26",
          r: "25",
          fill: "none"
        }), _jsx("path", {
          className: `${id}__check`,
          fill: "none",
          d: "M14.1 27.2l7.1 7.2 16.7-16.8"
        })]
      })]
    });
    $[6] = className;
    $[7] = id;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}